/**
 * Container shipment phases aligned with backend ShipmentStatus enum
 * (api/models/enums.py: DRAFT, BOOKED, IN_TRANSIT, ARRIVED, DELIVERED, ON_HOLD, CANCELLED).
 * ON_HOLD and CANCELLED are state modifiers; display phases are the 5 main lifecycle stages.
 */

/** Phase ids used for UI (section labels, timeline). Match backend lifecycle. */
export const CONTAINER_PHASE_IDS = ["draft", "booked", "in_transit", "arrived", "delivered"] as const;
export type ContainerPhaseId = (typeof CONTAINER_PHASE_IDS)[number];

/** Container status (frontend title-case from API). */
export type ContainerStatus =
    | "Draft"
    | "Booked"
    | "In Transit"
    | "Arrived"
    | "Delivered"
    | "On Hold"
    | "Cancelled";

/**
 * Maps container status to phase index 0–4 for progress indicators.
 * ON_HOLD → in_transit (2), CANCELLED → delivered (4).
 */
export function getContainerPhaseIndex(status: ContainerStatus | string | undefined): number {
    if (!status) return 0;
    const s = String(status).toLowerCase();
    if (s.includes("deliver") || s.includes("cancel")) return 4;
    if (s.includes("arriv")) return 3;
    if (s.includes("transit") || s.includes("hold")) return 2;
    if (s.includes("book")) return 1;
    return 0; // draft
}
